/**
 * AliyunController.java 对应的 model
 */

import Model from './model'
import { SetsConst } from 'core/constant'
const model = new Model()
class Aliyun {
    /**
     *  获取阿里云文件上传的post data
     */
    static getPostInfo(objectName) {
        return model.post(`aliyun/getPostInfo?bucketName=${SetsConst.BUCKET_PRIVATE}&objectName=${objectName}&random=true`)
    }
}
export default Aliyun



// WEBPACK FOOTER //
// ./bootsets/models/aliyun.js